<template lang="pug">
    v-dialog(v-model="dialog" max-width="640" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-overlay(:value="saving" absolute)
                v-progress-circular(indeterminate size="64")
            v-card-title.title.caption--text {{title}}
            v-container(tag="v-card-text" gris-list-xl)
                v-form(id="formId_LthOSu" ref="refForm" @submit="onSubmit")
                    v-layout(wrap)
                        v-flex(xs12)
                            v-text-field(:value="channelTitle" label="Channel Name (Read only)" readonly)

                        v-flex(xs12)
                            v-text-field(:value="subChannelTitle" label="Sub Channel Name (Read only)" readonly)

                        v-flex(xs12)
                            v-text-field(:value="roomTitle" label="Chat Room Name (Read only)" readonly)

                        v-flex(xs12)
                            v-autocomplete(v-model="sheetId" ref="refSheet" item-value="id" item-text="title"
                                :items="sheets" :loading="sheetLoading"
                                :rules="[rules.required]"
                                label="Sheet Name")
                                template(#item="data")
                                    v-list-item-content
                                        v-list-item-title {{data.item.title}}
                                        v-list-item-subtitle {{data.item.type}}

                        user-permission-finder(ref="refFinder"
                            :users-selected.sync="users"
                            @result="onGetSearchResult")
            v-card-actions
                v-spacer
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}

                v-btn(type="submit" form="formId_LthOSu" color="primary" depressed).px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.save')}}
</template>

<script>
import rules from "../../mixins/rules";
import general from "../../mixins/general";
import crud from "../../mixins/crud";
import cloneDeep from "lodash/cloneDeep";
import AdvancedSearchUserDialog from "../commons/AdvancedSearchUserDialog";
import UserPermissionFinder from "../commons/UserPermissionFinder";

export default {
  name: "EditDialog",
  components: { UserPermissionFinder, AdvancedSearchUserDialog },
  mixins: [rules, general, crud],
  props: ["socketId"],
  data() {
    return {
      mode: "create",
      dialog: false,
      saving: false,
      currentId: null,
      sheetId: null,
      subChannel: null,
      roomTitle: "",
      channelTitle: "",
      subChannelTitle: "",
      users: [],
      sheets: [],
      sheetLoading: false
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    },
    title: {
      get() {
        return this.$t(`pages.chat.dialog.title.${this.mode}`);
      }
    }
  },
  methods: {
    clear() {
      this.currentId = null;
      this.sheetId = null;
      this.subChannel = null;
      this.roomTitle = "";
      this.channelTitle = "";
      this.subChannelTitle = "";
      this.users = [];
      this.sheets = [];
    },
    show(mode, root, data = null) {
      this.clear();
      this.sheetLoading = true;
      this.mode = mode;
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["refForm"].resetValidation();
      });

      if (mode === "edit" && data) {
        this.$nextTick(() => {
          // TODO: do something...
          this.currentId = data.id;
          // this.name = data.title;
          // this.link = data.link;
          // this.check = data.chat;
          this.users = cloneDeep(data.users);
        });
      }

      this.subChannel = { ...root.subChannel };
      this.roomTitle = root.name;
      this.channelTitle = this.subChannel.channel.title;
      this.subChannelTitle = this.subChannel.title;

      this.axios
        .get(`sheets?allThin&calendarId=${this.subChannel.channel.id}`)
        .then(res => {
          this.sheets = res.data;
          this.$nextTick(() => {
            this.$refs["refSheet"].focus();
          });
        })
        .finally(() => (this.sheetLoading = false));
    },
    close() {
      this.$refs["refFinder"].close();
      this.$refs["refFinder"].clear();
      this.dialog = false;
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.$refs["refForm"].validate()) {
        this.$confirm(this.$t("messages.saveConfirmation")).then(value => {
          if (value) {
            this.saving = true;
            this.$store
              .dispatch("auth/fetchUser")
              .then(data => {
                if (data.perm_create_chat_room) {
                  setTimeout(() => {
                    const data = {
                      sheet_id: this.sheetId,
                      sub_channel_id: this.subChannel.id,
                      name: this.roomTitle,
                      user_ids: this.users.map(u => u.id)
                    };

                    this.axios({
                      url:
                        this.mode === "create"
                          ? `rooms`
                          : `rooms/${encodeURIComponent(this.currentId)}`,
                      method: this.mode === "create" ? `post` : `put`,
                      headers: {
                        "X-Socket-ID": this.socketId ? "" : this.socketId
                      },
                      data
                    })
                      .then(response => {
                        this.saving = false;
                        this.close();
                        this.$emit("saved", response.data.data);
                      })
                      .catch(error => {
                        this.saving = false;
                        if (this.mode === "create")
                          this.saveErrorHandler(error);
                        else this.updateErrorHandler(error);
                      });
                  }, 500);
                } else {
                  this.$emit("wrong", {
                    message: this.$t("general.permissionFailed.createChatRoom")
                  });
                  this.close();
                }
              })
              .catch(error => {
                const message = _.get(
                  error,
                  "response.data.message",
                  this.$t("general.somethingWrong")
                );
                this.$toasted.error(message);
              })
              .finally(() => (this.saving = false));
          }
        });
      }
    },
    async onGetSearchResult(result) {
      const { finder, users } = result;
      await this.axios
        .get(`sub-channels/${this.subChannel.id}/users`)
        .then(({ data }) => {
          finder.usersSearched = users.filter(u =>
            data.data.users.some(i => i.id === u.id)
          );
        });
    }
  }
};
</script>
